<div kendoWindowContainer></div>
<div kendoDialogContainer></div>
<div class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">Marketing Items</h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <div *ngIf="view" class="k-i-loading"></div>
    <kendo-grid [kendoGridBinding]="marketingItems" [pageSize]="20" [pageable]="true" [filterable]="'menu'"
      [sortable]="true" [groupable]="true">
      <kendo-grid-column field="marketingTypeName" title="Marketing Type" [width]="200"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description" [width]="200"></kendo-grid-column>
      <kendo-grid-column field="submitDate" title="Submit Date" [width]="200">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.submitDate | date : 'MM/dd/yyyy' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="reportDate" title="Report Date" [width]="200">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.reportDate | date : 'MM/dd/yyyy' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="marketingStatusTypeName" title="Status" [width]="150"
        [filterable]="false"></kendo-grid-column>
      <kendo-grid-column field="assignedTo" title="Assigned To" [width]="150"></kendo-grid-column>
      <kendo-grid-command-column title="Command" [width]="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
          <a (click)="viewMarketingItem(dataItem.marketingId)" title="View Marketing Item">
            <nb-icon icon="file-text-outline" style="font-size: 20px; cursor: pointer"></nb-icon>
          </a>
          <a (click)="editMarketingItem(dataItem.marketingId)" title="Edit Marketing Item">
            <nb-icon icon="edit-outline" style="font-size: 20px; cursor: pointer"></nb-icon>
          </a>
          <a (click)="viewFilesForMarketingItem(dataItem.marketingId)" title="View Files">
            <nb-icon icon="folder-outline" style="font-size: 20px; cursor: pointer"></nb-icon>
          </a>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>